import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import CircularProgress from '@material-ui/core/CircularProgress';
import parseJson from 'parse-json';

import SystemDesignDemo from '../../blocks/SystemDesignDemo';
import MainContainer from '../MainContainer';

import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/700.css';

import '@fontsource/prata/400.css';

import theme from '../../utils/theme';
import B1Home from '../../blocks/B1Home';
import B2EmmanuelleCosse from '../../blocks/B2EmmanuelleCosse';
import B3MarianneLouis from '../../blocks/B3MarianneLouis';
import B4Numbers from '../../blocks/B4Numbers';
import B5Federations from '../../blocks/B5Federations';
import B6Hlm from '../../blocks/B6Hlm';
import B7Slider from '../../blocks/B7Slider';
import B8Transition from '../../blocks/B8Transition';
import B9RE2020 from '../../blocks/B9RE2020';
import B10Promoting from '../../blocks/B10Promoting';
import B11Operations from '../../blocks/B11Operations';
import B12Needs from '../../blocks/B12Needs';
import B13Management from '../../blocks/B13Management';
import B14LifeQuality from '../../blocks/B14LifeQuality';
import B15Renovation from '../../blocks/B15Renovation';
import B16SocialImpact from '../../blocks/B16SocialImpact';
import B17Organisms from '../../blocks/B17Organisms';
import B18Escort from '../../blocks/B18Escort';
import B19Europe from '../../blocks/B19Europe';
import B20Overseas from '../../blocks/B20Overseas';
import B21Covid from '../../blocks/B21Covid';
import B22Actions from '../../blocks/B22Actions';
import B23Adaptation from '../../blocks/B23Adaptation';
import B24CovidImpact from '../../blocks/B24CovidImpact';
import B25Prejudice from '../../blocks/B25Prejudice';
import B26Slider from '../../blocks/B26Slider';
import B27Research from '../../blocks/B27Research';
import B28Partners1 from '../../blocks/B28Partners1';
import B29Partners2 from '../../blocks/B29Partners2';
import B30Thanks from '../../blocks/B30Thanks';

const BASE_URL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? '' : process.env.PUBLIC_URL;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      error: null,
      popupsState: {},
    };
    this.onPopup = this.onPopup.bind(this);
  }

  componentDidMount() {
    fetch('./data.json', { cache: 'no-store' })
      .then(r => r.text())
      .then(json => {
        try {
          const data = parseJson(json);
          this.setState({ data });
        } catch (error) {
          this.setState({ error });
        }
      });
  }

  renderError() {
    const { error } = this.state;
    if (!error) {
      return null;
    }
    return (
      <div style={{ padding: 30 }}>
        <h2>Erreur dans le parsing du fichier</h2>
        <pre>{error.message}</pre>
      </div>
    );
  }

  renderLoading() {
    const { data, error } = this.state;
    if (data || error) {
      return null;
    }
    return (
      <div style={{ width: '100%', paddingTop: '35vh', textAlign: 'center' }}>
        <h1 style={{ width: '100%', textAlign: 'center', marginBottom: 50 }}>Chargement...</h1>
        <CircularProgress />
      </div>
    );
  }

  onPopup(id, state) {
    this.setState(prev => ({ popupsState: { ...prev.popupsState, [id]: state } }));
  }

  renderApp() {
    const { data, error, popupsState } = this.state;
    if (!data || error) {
      return null;
    }
    if (data.demo === 'true') {
      return <SystemDesignDemo data={data} baseUrl={BASE_URL} />;
    }
    return (
      <MainContainer data={data} onPopup={this.onPopup}>
        <B1Home data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B2EmmanuelleCosse data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B3MarianneLouis data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B4Numbers data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B5Federations data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B6Hlm data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B7Slider data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B8Transition data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B9RE2020 data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B10Promoting data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B11Operations data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B12Needs data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B13Management data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B14LifeQuality data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B15Renovation data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B16SocialImpact data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B17Organisms data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B18Escort data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B19Europe data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B20Overseas data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B21Covid data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B22Actions data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B23Adaptation data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B24CovidImpact data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B25Prejudice data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B26Slider data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B27Research data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B28Partners1 data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B29Partners2 data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
        <B30Thanks data={data} baseUrl={BASE_URL} popupsState={popupsState} onPopup={this.onPopup} />
      </MainContainer>
    );
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {this.renderLoading()}
        {this.renderError()}
        {this.renderApp()}
      </ThemeProvider>
    );
  }
}

export default App;
